import { render, staticRenderFns } from "./message-scrolling.vue?vue&type=template&id=27c29600&"
import script from "./message-scrolling.vue?vue&type=script&lang=ts&"
export * from "./message-scrolling.vue?vue&type=script&lang=ts&"
import style0 from "./message-scrolling.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports